// this will load the Shopify analytics script that is required for shopify session tracking
// session cookies are set to strictly necessary
document.addEventListener('DOMContentLoaded', function () {
	setTimeout(() => {
		window.Shopify.customerPrivacy.setTrackingConsent(
			{
				"analytics":    true,
			},
			() => {}
		);
	}, 1000);
});
